export default __webpack_public_path__ + "static/media/kitchen5-beforeB-480w.3de12ce7.avif";